import React from 'react'
import { Button, colors, typography } from '@resiliatech/birdsong'
import TrendingUpIcon from '@mui/icons-material/TrendingUp'
import styled from '@emotion/styled'

type TaskListEmptyStateProps = {
  onAddTask?: () => void
}

const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  text-align: center;
  width: 100%;
  min-height: 300px;
`

const IconContainer = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
`

const Title = styled.div`
  font-family: 'Helvetica Neue' !important;
  font-size: 18px;
  margin-bottom: 10px;
`

const Description = styled.p`
  font-family: 'Helvetica Neue' !important;
  font-size: 16px;
  margin-bottom: 24px;
  max-width: 500px;
`

export const TaskListEmptyState = ({ onAddTask }: TaskListEmptyStateProps) => (
  <EmptyStateContainer>
    <IconContainer>
      <TrendingUpIcon sx={{ fontSize: 36, color: '#3361CC' }} />
    </IconContainer>
    <Title>No Records To Show</Title>
    <Description>
      Set up a task to begin tackling different parts of this goal.
    </Description>
    <Button
      variant='outlined'
      onClick={onAddTask}
      sx={{
        borderRadius: '20px',
        padding: '6px 24px',
        textTransform: 'none',
        fontWeight: 500,
        backgroundColor: 'white',
      }}
    >
      Add Task
    </Button>
  </EmptyStateContainer>
)
